import { useState, useEffect, useRef, useCallback } from 'react';

export default function Testimonials() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [animKey, setAnimKey] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const testimonials = [
    {
      type: 'photo',
      name: 'Braydan Urban-',
      achievement: 'NJIT Pitcher',
      quote: 'EPL transformed my entire approach to pitching. When I first arrived, I was struggling with consistency and velocity. Through their biomechanical analysis and personalized training program, I gained 13 mph on my fastball and developed the mental toughness needed to compete at the Division I level. The family atmosphere at EPL made all the difference in my development as both a pitcher and a person.',
      image: 'https://public.readdy.ai/ai/img_res/edited_2f75b8e948ea1651670fbdfa8c15dcf3_682bb143.jpg'
    },
    {
      type: 'photo',
      quote: 'EPL was an eye opener for me. Allen truly cares for his students and knows what it takes to be a winner which is exactly what I needed. My time with EPL developed me in ways I don\'t think I ever could anywhere else, because here it\'s more than just the physical aspect of the game. EPL will always be my recommendation for players looking to develop physically, mentally and overall as a person, and a baseball player.',
      name: 'JC Gilmore-',
      achievement: 'SouthEastern University, NAIA CWS Champions',
      image: 'https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/6dac262a1757ddac9c3f33306ca34417.jpeg'
    },
    {
      type: 'photo',
      name: 'Kevin Stevens-',
      achievement: 'Signed with New York Yankee\'s Organization',
      quote: 'EPL has absolutely changed my career. Coming in I can\'t lie I was lost in the whole deep dive of pitching. Having two elbow surgeries and wanting to continue to chase the dream of the big leagues it was time to work with someone that actually cared about individuals performance and better yet HEALTH. After 3 weeks with EPL my arm has truly never felt better in my entire career. This place has changed my career and in the process of doing so, changed my mental side of baseball and life as well. Can\'t say enough about this place, except absolute gratefulness.',
      image: 'https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/5723f08cd84f6f4519ff70547cc98223.jpeg'
    },
    {
      type: 'photo',
      quote: 'At EPL, I gained a deeper understanding of my body\'s mechanics and was taught the most efficient movement patterns for throwing. The facility fosters a true family environment, where everyone genuinely supports one another. Without Allen and the entire EPL team, I\'m not sure where my career would be today.',
      name: 'Colten Davis-',
      achievement: 'Signed with the Algondoeros de Union Laguna',
      image: 'https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/730167fcca9b16ac40a2e5eb9aa32cd0.jpeg'
    },
    {
      type: 'photo',
      name: 'Zane Morehouse-',
      achievement: 'Signe with the Cleveland Guardians',
      quote: 'EPL transformed my approach to pitching. When I arrived, I was throwing 86 mph and struggling with command. Through their biomechanical analysis and personalized training program, I gained 8 mph on my fastball and developed pinpoint accuracy. More importantly, I learned how to take care of my arm and prevent injuries. The mental training aspect prepared me for the pressure of college baseball.',
      image: 'https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/00dce1a3ed68963c74f24df0dd66195b.jpeg'
    },
    {
      type: 'photo',
      name: 'Daniel Urban-',
      achievement: 'Father of EPL Athlete',
      quote: 'My son has been training at EPL year-round for about 3 years, and this journey has impacted his life in many positive ways. The opportunities he has for his future exceeded every expectation we have had. My son has learned that you must earn your spot through hard work and determination. He has gained measurable improvements in velocity and command of pitching, along with overall confidence on the mound. Allen doesn\'t just run him through drills, he assessed his mechanics, movement patterns, strengths, and areas for improvement, then built a program specifically around him.',
      image: 'https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/a3ad889a06e3d0c5198979f5d9c628a3.png'
    },
    {
      type: 'photo',
      quote: 'The training at EPL goes beyond just physical development. Allen\'s approach to mental preparation and understanding your body mechanics creates a foundation that translates to success both on and off the field.',
      name: 'Heath Autrey-',
      achievement: 'Corsicana High School Head Coach',
      image: 'https://public.readdy.ai/ai/img_res/edited_701c9fac7e1157be8a2e0008ad3e9b84_3a1bc37d.jpg'
    },
    {
      type: 'photo',
      name: 'Zane Petty-',
      achievement: 'Signed Cleveland Guardians',
      quote: 'The Elite performance lab has helped me establish a understanding for my body and how to produce the most out of it that I can',
      image: 'https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/b17531b41d6eb5e740b9d4ecc1f55a7a.jpeg'
    },
    {
      type: 'photo',
      quote: 'Elite Performance Lab has not only helped me understand my body better but has helped me as the human I am today. Allen has helped me a tremendous amount with college looks and how to become a better athlete overall. My favorite thing about being here is that it is a family and no matter what I can trust anyone and everyone that comes through or is allowed to be in the facility.',
      name: 'Micah Early_',
      achievement: 'ENMU Pitcher',
      image: 'https://public.readdy.ai/ai/img_res/edited_ba1226d8dc95666e85899f34611c420e_85de3fe0.jpg'
    },
    {
      type: 'photo',
      quote: 'As a suburban, California kid thrust into the country lifestyle of Corsicana, Texas, I learned very quickly how one\'s mindset affects everything. Although EPL taught me how to throw a baseball 92 mph without my shoulder hurting, it opened my eyes to the fact that "As a man thinks, so he shall be." By introducing concepts like positive reaffirmation and the law of attraction, Allen Morehouse explained how only those with mental fortitude prevail. Morehouse explained how favoritism is a part of life, so be the favorite; if a coach only plays the players he likes, then become that player. Basically, I was taught to look in the mirror before pointing fingers, and there are no excuses like the lack of height, weight or athleticism. Yes, everybody is born into different circumstances with some people having more opportunities than others. However, if you are cold, hungry or tired enough, you will find a way to succeed. This does not only translate to baseball, but to literally everything one could possibly achieve in life. Obviously, I did not just hear of these principles one summer and have everything click; but, after experiencing moments of self-pity, doubt and negative self thoughts, I can reflect on the past two years and observe the process that shaped who I am today. Most importantly, Allen asked us what our identity was, and initially, I was too scared to answer the question. I tried, but after cross-examination, I whimpered away due to lack of self-belief. Now, I can confidently say that I know who I am, and if someone were to question me, I would not care, because it does not matter what others think of me, "other people\'s opinions are none of our business." I am a son of God who was graciously given an opportunity to play baseball at the collegiate level, and whether professional baseball is in my future or not, I will not worry, because baseball is not my identity. Baseball is a luxury, and therefore I am going to give my absolute effort and leave no regrets with my play. Altogether, thank you Allen Morehouse and EPL for not only sharpening my baseball skills, but helping shape my identity and how I see myself.',
      name: 'Ian Carr-',
      achievement: 'WestCliff University',
      image: 'https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/d1cc7e8cbfb5721fcd5d07184286b1f3.jpeg'
    },
    {
      type: 'photo',
      quote: 'I\'m a pitcher in college and I first started at EPL around March 2025 — at the beginning I had just come off Tommy John surgery. Allen was telling me my situation pretty much and I obviously didn\'t like it at the time. I decided to join EPL and ever since then it\'s been the best decision of my life. Allen Morehouse and his family have been a huge part of my life and I don\'t even know if they know it.',
      name: 'Briley Van-',
      achievement: 'ENMU Pitcher',
      image: 'https://public.readdy.ai/ai/img_res/edited_9eef4e5a24d19cded24ca76831496911_115f299d.jpg'
    },
    {
      type: 'photo',
      name: 'Raul Luna-',
      achievement: 'Father of EPL Athlete - Arkansas Tech Commit 2026',
      quote: 'I met Allen Morehouse through my brother\'s friend Boon. He introduced me to Allen, we went to his facility one day and he accepted my son into his program. He is a great person he has helped my son in a lot of things mentally and physically like getting his body in shape. His velocity and knowledge has increased since he\'s been there almost 2 years ago. He has committed to Arkansas Tech for 2026 fall.',
      image: 'https://public.readdy.ai/ai/img_res/91b1af05460f61077482fdde75329cdb.jpg'
    },
    {
      type: 'photo',
      name: 'Easton Autrey-',
      achievement: 'Texas Commitment, HS Nationally Ranked Prospect',
      quote: 'EPL has not only help me develop as a baseball player but as a person as well. Beyond the obvious Velo increase and overall numbers increase EPL has helped me understand my body patterns and specific movements that make me better. I\'ve learned mental cues and understanding about how you think can completely change the outcome. Allen is one of the most approachable people I\'ve ever met and it\'s comforting knowing you can call anytime knowing he\'s there for you.',
      image: 'https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/4152bfb4a68b6d594e417bb6987bf74e.png'
    },
    {
      type: 'photo',
      name: 'Stephen Fugedy-',
      achievement: 'College Pitcher',
      quote: 'Where I could start on EPL isn\'t the easiest thing to do because of how much it has built me into the man I have become today from where I was three years ago. EPL isn\'t just a training facility it\'s a family that you build together and it doesn\'t matter where you are in your athletic career from the bottom or top. Everyone that goes there and sticks through the program becomes a member of the family and learn so many things that will change your life completely.',
      image: 'https://readdy.ai/api/search-image?query=young%20male%20baseball%20pitcher%20athlete%20standing%20confidently%20in%20athletic%20training%20facility%20wearing%20baseball%20gear%2C%20determined%20focused%20expression%2C%20strong%20athletic%20build%2C%20professional%20sports%20portrait%20photography%20with%20dark%20background%20and%20dramatic%20lighting&width=400&height=400&seq=epl_athlete_ajrodeo&orientation=squarish'
    },
    {
      type: 'photo',
      name: 'Adin Morehouse-',
      achievement: 'College Catcher "The Captain"',
      quote: '"First and foremost I\'m a Lifer". EPL has done more for me off of the field than on the field. Yes, I am a great catcher and leader on the field but, more importantly I know who I am and that baseball is just what I do. Allen has shown me how to handle adversity without loosing my cool. EPL has made it to where I know where my body is in time and space and can make pitch to pitch adjustments in game. All in all, without EPL I would not be the man I am today on and off of the field.',
      image: 'https://public.readdy.ai/ai/img_res/edited_192aa1c6438839c43f39fd8e0a87e70c_882dd13a.jpg'
    },
    {
      type: 'quote',
      name: 'Julie & TY Crittenden',
      achievement: 'Parents of EPL Athlete',
      quote: 'The Elite Performance Lab has been instrumental in enhancing our son\'s mental and physical abilities, significantly contributing to his advancement in the sport. By providing essential tools and support, EPL has enabled him to take his game to new heights. He consistently displays enthusiasm for training at the facility, underscoring his dedication to hard work and progress.'
    }
  ];

  const total = testimonials.length;
  const visibleCount = 3;
  const maxIndex = total - visibleCount;

  const startInterval = useCallback(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrentIndex(prev => {
        const next = prev >= maxIndex ? 0 : prev + 1;
        setAnimKey(k => k + 1);
        return next;
      });
    }, 3500);
  }, [maxIndex]);

  useEffect(() => {
    if (!isPaused) {
      startInterval();
    } else {
      if (intervalRef.current) clearInterval(intervalRef.current);
    }
    return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
  }, [isPaused, startInterval]);

  const goTo = (index: number) => {
    setAnimKey(k => k + 1);
    setCurrentIndex(Math.max(0, Math.min(index, maxIndex)));
  };

  const prev = () => goTo(currentIndex === 0 ? maxIndex : currentIndex - 1);
  const next = () => goTo(currentIndex >= maxIndex ? 0 : currentIndex + 1);

  const visibleTestimonials = testimonials.slice(currentIndex, currentIndex + visibleCount);

  return (
    <section id="testimonials" className="py-16 md:py-24 bg-gray-900 relative overflow-hidden">

      {/* Background glow orbs */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-teal-500/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-teal-400/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute top-1/2 left-0 w-64 h-64 bg-teal-600/4 rounded-full blur-2xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-5 lg:px-12 relative z-10">
        <div className="text-center mb-12">
          {/* Label with glow line */}
          <div className="inline-flex flex-col items-center gap-2 mb-4">
            <span className="text-teal-400 text-xs font-bold uppercase tracking-wider">Athlete Success Stories</span>
            <div className="flex items-center gap-2">
              <div className="w-8 h-px bg-gradient-to-r from-transparent to-teal-400" />
              <div className="w-2 h-2 rounded-full bg-teal-400 shadow-[0_0_8px_2px_rgba(45,212,191,0.6)]" />
              <div className="w-8 h-px bg-gradient-to-l from-transparent to-teal-400" />
            </div>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mt-1">From High School to College &amp; Beyond</h2>
          <p className="text-gray-400 text-lg mt-4 max-w-3xl mx-auto">Over 60+ college athletes, 8 professional players, and countless success stories. See what EPL athletes and families are saying about their transformative experience.</p>
        </div>

        {/* Carousel */}
        <div
          className="relative"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => { setIsPaused(false); setExpandedIndex(null); }}
        >
          {/* Prev Button */}
          <button
            onClick={prev}
            className="absolute -left-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center bg-gray-800 border border-gray-600 hover:border-teal-500 hover:bg-gray-700 text-white rounded-full transition-all cursor-pointer shadow-lg hover:shadow-teal-500/20"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>

          {/* Cards */}
          <div className="grid grid-cols-3 gap-6 overflow-hidden">
            {visibleTestimonials.map((testimonial, i) => {
              const globalIndex = currentIndex + i;
              return (
                <div
                  key={`${animKey}-${i}`}
                  className="transition-all duration-500"
                  style={{
                    animation: `fadeSlideIn 0.45s ease both`,
                    animationDelay: `${i * 80}ms`,
                  }}
                >
                  {testimonial.type === 'quote' ? (
                    <div className="bg-gray-800 rounded-2xl p-6 sm:p-8 h-full border-2 border-gray-700 hover:border-teal-500 transition-all flex flex-col group relative overflow-hidden">
                      {/* subtle inner glow on hover */}
                      <div className="absolute inset-0 bg-gradient-to-br from-teal-500/0 group-hover:from-teal-500/5 to-transparent transition-all duration-500 rounded-2xl pointer-events-none" />
                      <i className="ri-double-quotes-l text-4xl text-teal-400 mb-4 relative z-10"></i>
                      <p className={`text-gray-300 text-sm leading-relaxed mb-2 italic relative z-10 ${expandedIndex === globalIndex ? '' : 'line-clamp-4'}`}>"{testimonial.quote}"</p>
                      <button
                        onClick={() => setExpandedIndex(expandedIndex === globalIndex ? null : globalIndex)}
                        className="text-teal-400 text-xs font-semibold hover:text-teal-300 transition-colors cursor-pointer whitespace-nowrap text-left mb-4 relative z-10"
                      >
                        {expandedIndex === globalIndex ? 'Read Less ↑' : 'Read More ↓'}
                      </button>
                      <div className="border-t border-gray-700 pt-4 mt-auto relative z-10">
                        <div className="font-bold text-white text-sm">{testimonial.name}</div>
                        <div className="text-xs text-teal-400 font-semibold">{testimonial.achievement}</div>
                      </div>
                    </div>
                  ) : (
                    <div className="relative rounded-2xl overflow-hidden cursor-pointer h-full bg-gray-800 border-2 border-gray-700 hover:border-teal-500 transition-all flex flex-col group">
                      {/* subtle inner glow on hover */}
                      <div className="absolute inset-0 bg-gradient-to-br from-teal-500/0 group-hover:from-teal-500/5 to-transparent transition-all duration-500 rounded-2xl pointer-events-none z-0" />
                      {testimonial.image && (
                        <div className="flex justify-center pt-6 relative z-10">
                          {/* Glowing ring behind photo */}
                          <div className="relative">
                            <div className="absolute inset-0 rounded-full bg-teal-400/20 blur-md scale-110 group-hover:bg-teal-400/35 transition-all duration-500" />
                            <img
                              src={testimonial.image}
                              alt={testimonial.name}
                              className="w-[13.5rem] h-[13.5rem] object-cover object-[center_top] rounded-full border-4 border-teal-500 relative z-10 group-hover:border-teal-400 transition-all duration-300"
                            />
                          </div>
                        </div>
                      )}
                      {testimonial.quote && (
                        <div className="px-5 pt-4 pb-2 flex-1 relative z-10">
                          <i className="ri-double-quotes-l text-3xl text-teal-400 mb-2 block"></i>
                          <p className={`text-gray-300 text-sm leading-relaxed italic ${expandedIndex === globalIndex ? '' : 'line-clamp-4'}`}>
                            "{testimonial.quote}"
                          </p>
                          <button
                            onClick={() => setExpandedIndex(expandedIndex === globalIndex ? null : globalIndex)}
                            className="mt-2 text-teal-400 text-xs font-semibold hover:text-teal-300 transition-colors cursor-pointer whitespace-nowrap"
                          >
                            {expandedIndex === globalIndex ? 'Read Less ↑' : 'Read More ↓'}
                          </button>
                        </div>
                      )}
                      <div className="px-5 pb-5 pt-3 border-t border-gray-700 mt-3 relative z-10">
                        <div className="font-bold text-white text-base">{testimonial.name}</div>
                        <div className="text-teal-400 font-semibold text-xs">{testimonial.achievement}</div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Next Button */}
          <button
            onClick={next}
            className="absolute -right-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center bg-gray-800 border border-gray-600 hover:border-teal-500 hover:bg-gray-700 text-white rounded-full transition-all cursor-pointer shadow-lg hover:shadow-teal-500/20"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>

        {/* Dot Indicators */}
        <div className="flex justify-center gap-2 mt-8">
          {Array.from({ length: maxIndex + 1 }).map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className={`transition-all cursor-pointer rounded-full ${currentIndex === i ? 'w-6 h-2 bg-teal-400 shadow-[0_0_6px_2px_rgba(45,212,191,0.5)]' : 'w-2 h-2 bg-gray-600 hover:bg-gray-400'}`}
            />
          ))}
        </div>

        {/* Stats & CTA */}
        <div className="mt-16 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-6 sm:gap-8 bg-gray-800 rounded-2xl px-8 sm:px-12 py-6 sm:py-8 border border-gray-700 w-full sm:w-auto relative overflow-hidden">
            {/* Subtle teal glow strip at top */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-teal-500/60 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-teal-500/20 to-transparent" />
            <div className="text-center relative z-10">
              <div className="text-3xl sm:text-4xl font-black text-white">60+</div>
              <div className="text-xs sm:text-sm text-gray-400 font-semibold">College Athletes</div>
            </div>
            <div className="hidden sm:block w-px h-12 bg-gray-600 relative z-10"></div>
            <div className="block sm:hidden w-full h-px bg-gray-600"></div>
            <div className="text-center relative z-10">
              <div className="text-3xl sm:text-4xl font-black text-white">8</div>
              <div className="text-xs sm:text-sm text-gray-400 font-semibold">Pro Players</div>
            </div>
            <div className="hidden sm:block w-px h-12 bg-gray-600 relative z-10"></div>
            <div className="block sm:hidden w-full h-px bg-gray-600"></div>
            <div className="text-center relative z-10">
              <div className="text-3xl sm:text-4xl font-black text-white">18+</div>
              <div className="text-xs sm:text-sm text-gray-400 font-semibold">Years Experience</div>
            </div>
          </div>

          <div className="mt-8 bg-gradient-to-r from-teal-500/10 to-teal-600/10 rounded-2xl p-8 border border-teal-500/30 relative overflow-hidden">
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-teal-400/50 to-transparent" />
            <h3 className="text-xl font-bold text-white mb-4">Ready to Join These Success Stories?</h3>
            <p className="text-gray-300 text-sm mb-6">Every athlete's journey is unique, but they all start with the decision to invest in proper training and development.</p>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-600 text-white px-6 py-3 rounded-full font-semibold text-sm transition-all whitespace-nowrap cursor-pointer shadow-lg hover:shadow-teal-500/30"
            >
              Start Your Journey
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeSlideIn {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}
